var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"900px","scrollable":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('type-selector',{attrs:{"content_types":_vm.content_types},on:{"select":_vm.selectType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }